import { ReactNode } from "react";

import BulkActionsConfirmActionStep from "components/BulkActions/ConfirmActionStep";
import { BulkActionsVariant } from "components/BulkActions/types";

import { UserRolesBulkActionsAnalyticsPayload, UserRolesBulkActionsSelectedAction } from "../types";
import UserRolesBulkActionsConfirmActionStepDefault from "./Default";
import { UserRolesBulkActionsConfirmActionStepProps } from "./types";
import { UserRolesMutationVariables } from "../useUserRolesBulkActions/types";

type UserRolesBulkActionsConfirmActionFormProps = {
  action: UserRolesBulkActionsSelectedAction;
  variant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: UserRolesMutationVariables,
    analyticsPayload: UserRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const UserRolesBulkActionsConfirmActionForm = ({
  action,
  variant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: UserRolesBulkActionsConfirmActionFormProps) => {
  const props: UserRolesBulkActionsConfirmActionStepProps = {
    bulkActionsVariant: variant,
    onConfirm,
    onCancel,
    action,
    customConfirmationMessage,
  };

  const actionComponent = <UserRolesBulkActionsConfirmActionStepDefault {...props} />;

  return <BulkActionsConfirmActionStep>{actionComponent}</BulkActionsConfirmActionStep>;
};

export default UserRolesBulkActionsConfirmActionForm;
